import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

/**
 * Selo "Novo" de recurso recém-lançado, no mesmo desenho do da área de membros.
 *
 * `primary.main` com `contrastText` mantém o contraste no tema claro e no escuro.
 */
export default function NewFeatureChip({ label = 'Novo', sx, ...other }) {
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        height: 16,
        borderRadius: '6px',
        fontSize: 10,
        fontWeight: 700,
        flexShrink: 0,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        // Altura de linha própria: o `info` do menu lateral envolve o selo com `lineHeight: 0`, e o
        // texto sumia dentro do chip.
        '& .MuiChip-label': { px: 0.75, lineHeight: '16px' },
        ...sx,
      }}
      {...other}
    />
  );
}

NewFeatureChip.propTypes = {
  label: PropTypes.string,
  sx: PropTypes.object,
};
